import { Typography } from "@mui/material";
import { useStyles } from "../../Search.styles";

export const SearchResultMessage = ({ searchResultFound }) => {
	const classes = useStyles();
	return (
		<Typography variant="body2" component="div" className={classes.searchResultFoundMessage}>
			{searchResultFound} matching result(s) found
		</Typography>
	);
};
